import { Heart, Shield, Eye, Award } from 'lucide-react';

export const MOCK_DATA = {
  services: [
    {
      title: "Borophene & Graphene Coating",
      description: "Market-first Borophene coating with unmatched resistance and intense water-repelling shine.",
      badge: "MARKET FIRST",
      image: "/img/ceramic-coating.webp",
      features: [
        "10H Hardness Protection",
        "Multi-year guarantee",
        "Mirror-finish shine",
        "Ultimate water resistance",
        "Professional application"
      ],
      price: "₹15,000"
    },
    {
      title: "ArmouraX Ultra Shield PPF",
      description: "Revolutionary PPF with factory ceramic coating, up to 300 microns thick for maximum defense.",
      badge: "PREMIUM",
      image: "/img/armourax-ppf.webp",
      features: [
        "Factory ceramic-coated film",
        "Self-healing technology",
        "Up to 300 microns PPF available",
        "8 years to lifetime warranty",
        "Bubble-free installation"
      ],
      price: "₹25,000"
    },
    {
      title: "Professional Paint Correction",
      description: "Expert-level paint correction to remove swirl marks and restore showroom finish.",
      badge: "EXPERT SERVICE",
      image: "/img/paint-correction.webp",
      features: [
        "Multi-stage polishing",
        "Swirl mark removal",
        "Scratch elimination",
        "Mirror gloss finish",
        "Paint depth restoration"
      ],
      price: "₹8,000"
    },
    {
      title: "Deep Interior Detailing",
      description: "Professional steam cleaning, leather restoration, and complete interior sanitization.",
      badge: "COMPLETE CARE",
      image: "https://images.unsplash.com/photo-1583573278124-e8d4fd3edf3c?auto=format&fit=crop&fm=webp&w=960&q=68",
      features: [
        "Steam sanitization",
        "Leather conditioning",
        "Fabric deep cleaning",
        "Odor elimination",
        "Dashboard restoration"
      ],
      price: "₹5,000"
    },
    {
      title: "RTO-Approved UV & Heat Control Films",
      description: "Premium windshield and side-window film solutions that cut heat, block harmful UV rays, and improve cabin comfort while staying compliant.",
      badge: "RTO APPROVED",
      image: "/img/glass-uv-film-application.webp",
      features: [
        "RTO-approved visibility options",
        "Heat rejection for cooler cabin comfort",
        "UV ray protection",
        "Reduced glare for safer driving",
        "Bubble-free professional installation"
      ],
      price: "₹3,500"
    },
    {
      title: "Complete Restoration",
      description: "Full vehicle restoration for older cars needing major aesthetic repair and renewal.",
      badge: "TRANSFORMATION",
      image: "/img/restoration.webp",
      features: [
        "Body damage repair",
        "Complete paint restoration",
        "Chrome trim renewal",
        "Interior refurbishment",
        "Full detailing package"
      ],
      price: "₹50,000"
    }
  ],

  additionalServices: [
    "Car Denting & Painting",
    "Scratch Removal",
    "Underbody Coating",
    "Engine Cleaning",
    "Premium Foam Wash",
    "Headlight Polishing",
    "Alloy Wheel Coating",
    "9D/7D Floor Mats",
    "Seat Cover Installation",
    "Ambient Lighting",
    "Door Visors",
    "Car Accessories"
  ],

  process: [
    {
      title: "Initial Assessment & Premium Wash",
      description: "Detailed paint inspection followed by Premium Foam Wash to safely remove all loose dirt and dust, ensuring a clean, swirl-free start."
    },
    {
      title: "Deep Cleaning & Surface Prep",
      description: "Meticulous deep cleaning of wheels, plastic trims, and underbody parts using safe pH-balanced cleaner for complete surface preparation."
    },
    {
      title: "Paint Correction & Final Prep",
      description: "Multi-stage rubbing and polishing to remove swirl marks and scratches, followed by IPA wipe to strip all oils for perfect coating bond."
    },
    {
      title: "Exterior Protection Application",
      description: "Application of Borophene, Ceramic Coating, or PPF to paint surfaces, along with specialized Alloy Wheel and glass coatings."
    },
    {
      title: "Interior Coating & Sanitization",
      description: "Professional seats, dashboard, and gloss part ceramic coating application, followed by complete cabin sanitization and fabric cleaning."
    },
    {
      title: "Product Curing & Accessory Integration",
      description: "Adequate curing time for coatings and PPF to harden completely, with finalization of all accessory installations and functionality checks."
    },
    {
      title: "Quality Inspection & Handover",
      description: "Exhaustive expert inspection under high-intensity lights, product care guide provision, and confident handover with warranty details."
    }
  ],

  whyChooseUs: [
    {
      icon: <Heart className="h-6 w-6" />,
      title: "Shared Passion & 15+ Years Expertise",
      description: "We're car owners ourselves and treat your vehicle like family. Over 15 years of industry experience ensures the highest quality service at affordable pricing."
    },
    {
      icon: <Eye className="h-6 w-6" />,
      title: "100% Transparent Glass-Walled Studio",
      description: "Rajasthan's largest detailing studio with glass walls and doors. Watch the entire process and confirm our commitment to quality work."
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: "Dust-Free Coating Environment",
      description: "Dedicated large dust-free coating room sealed with toughened glass ensures no contamination, guaranteeing a perfect, flawless finish."
    },
    {
      icon: <Award className="h-6 w-6" />,
      title: "Luxury Customer Experience",
      description: "Spacious, comfortable customer lounge with complimentary snacks, tea, and coffee. Sparkling clean studio providing a seamless, relaxing experience."
    }
  ],

  instagramGrid: [
    {
      url: "https://images.pexels.com/photos/29504461/pexels-photo-29504461.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Premium Foam Wash"
    },
    {
      url: "https://images.pexels.com/photos/6873121/pexels-photo-6873121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Luxury Detailing"
    },
    {
      url: "https://images.unsplash.com/photo-1648709263135-a193121a82f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxnbG9zc3klMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODQxfDA&ixlib=rb-4.1.0&q=85",
      caption: "Mirror Finish"
    },
    {
      url: "https://images.unsplash.com/photo-1614200179396-2bdb77ebf81b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "Ferrari Coating"
    },
    {
      url: "https://images.unsplash.com/photo-1580679568899-be51739ba2df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "Porsche Gloss"
    },
    {
      url: "https://images.unsplash.com/photo-1601929862217-f1bf94503333?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "BMW Detailing"
    },
    {
      url: "https://images.pexels.com/photos/20051462/pexels-photo-20051462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Paint Correction"
    },
    {
      url: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?q=80&w=2000",
      caption: "Interior Detail"
    },
    {
      url: "https://images.unsplash.com/photo-1711513503808-53380d724182?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3NzM0ODQxNDd8MA&ixlib=rb-4.1.0&q=85",
      caption: "Ceramic Shield"
    },
    {
      url: "https://images.unsplash.com/photo-1739161763843-4adaf7709291?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmclMjBzdHVkaW98ZW58MHx8fHwxNzczNDg0MTU3fDA&ixlib=rb-4.1.0&q=85",
      caption: "Studio Work"
    },
    {
      url: "https://images.unsplash.com/photo-1711512302274-8aafe96481bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxjZXJhbWljJTIwY29hdGluZ3xlbnwwfHx8fDE3NzM0ODQxNDd8MA&ixlib=rb-4.1.0&q=85",
      caption: "PPF Installation"
    },
    {
      url: "https://images.pexels.com/photos/6873121/pexels-photo-6873121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Professional Care"
    }
  ],

  gallery: [
    {
      url: "https://images.pexels.com/photos/29504461/pexels-photo-29504461.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Premium Foam Wash Application"
    },
    {
      url: "https://images.pexels.com/photos/6873121/pexels-photo-6873121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      caption: "Luxury Car Deep Cleaning"
    },
    {
      url: "https://images.unsplash.com/photo-1648709263135-a193121a82f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxnbG9zc3klMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODQxfDA&ixlib=rb-4.1.0&q=85",
      caption: "Mirror-Finish Headlight Detail"
    },
    {
      url: "https://images.unsplash.com/photo-1614200179396-2bdb77ebf81b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "Ceramic Coating on Ferrari"
    },
    {
      url: "https://images.unsplash.com/photo-1580679568899-be51739ba2df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "Porsche Perfect Gloss Finish"
    },
    {
      url: "https://images.unsplash.com/photo-1601929862217-f1bf94503333?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXJ8ZW58MHx8fHwxNzczNDk5ODUwfDA&ixlib=rb-4.1.0&q=85",
      caption: "BMW M3 Complete Detailing"
    }
  ],

  testimonials: [
    {
      name: "Anmol Verma",
      car: "Tata Safari Dark Edition",
      service: "PPF (Paint Protection Film)",
      rating: 5,
      review: "I recently got Paint Protection Film (PPF) done on my Tata Safari Dark Edition from Detailing Bhai, and the experience was absolutely top-class. The finish looks stunning and perfectly complements the black color of the car."
    },
    {
      name: "Pradeep Shukla",
      car: "Kia Sonet",
      service: "Ceramic Coating",
      rating: 5,
      review: "Absolutely fantastic experience at Detailing Bhai! I got ceramic coating done on my Kia Sonet, and the results are outstanding — the car looks brand new. Huge thanks to the entire team, especially Kishan bhai, for delivering great value."
    },
    {
      name: "Anky Ghotia",
      car: "Maruti Suzuki Ertiga",
      service: "Full Car Detailing",
      rating: 5,
      review: "I recently got my car detailed by Detailing Bhai, and I'm extremely impressed. They did dry cleaning and a full car wash, and the results were amazing. The team handled my car very gently and with great care. Their staff is cooperative, polite, and professional. The quality of work is top-notch, and the pricing is very reasonable for the service they provide. If you truly care about your car, I highly recommend Detailing Bhai."
    },
    {
      name: "Rahul Jadawta",
      car: "Tata Harrier EV",
      service: "PPF (Paint Protection Film)",
      rating: 5,
      review: "Flawless PPF Installation on my Harrier EV! Highly Recommended! I recently got the PPF done on my Tata Harrier EV and the results are exceptional. The team's attention to detail and professionalism is commendable."
    },
    {
      name: "Nitesh Jharotiya",
      car: "Hyundai Creta",
      service: "3-Year Borophene Ceramic Coating",
      rating: 5,
      review: "If you love your car like I do, please bring your car here to transform it into showroom look. I have got 3 years Borophene Ceramic Coating for my Hyundai Creta. Highly recommend."
    },
    {
      name: "Aniket Shabu",
      car: "Volkswagen Taigun",
      service: "Premium Foam Wash",
      rating: 5,
      review: "I really appreciate the extra care and effort your team put into cleaning my car today. You went beyond what was expected, and the attention to detail truly shows. It's small gestures like this that make a big difference. Thank you for your excellent service and the pride you take in your work!"
    }
  ],

  faqs: [
    {
      question: "What is the difference between Ceramic Coating and PPF?",
      answer: "Ceramic coating is a premium liquid layer focused on gloss, UV resistance, water repellency, and easier maintenance. PPF is a high-performance physical film designed to absorb road impact and protect paint from chips and external damage. At Detailing Bhai, both services are executed with strict preparation standards and genuine products only."
    },
    {
      question: "Should I choose Ceramic, PPF, or both?",
      answer: "For a complete single-solution approach, choose either full-body ceramic coating or full-body PPF based on your priority. If your priority is deep gloss and easy upkeep, ceramic is ideal. If your priority is stronger physical paint defense from road impact, full PPF is ideal. We recommend only what is right for your vehicle usage, never unnecessary upselling."
    },
    {
      question: "Do your ceramic and PPF packages include interior protection too?",
      answer: "Yes, our packages include valuable complimentary add-on services where interior surfaces like leather seats, dashboard, and gloss trims receive protective ceramic treatment. We also include multiple premium add-ons without hidden charges, because complete protection means exterior plus interior care."
    },
    {
      question: "Myth: Ceramic coating can stop scratches and dents completely. Is that true?",
      answer: "No. Ceramic improves surface resistance and finish quality, but it is not meant to stop major impact damage. Honest guidance is part of our process, so we clearly explain expectations before work starts and recommend the right protection path without false claims."
    },
    {
      question: "Myth: PPF always turns yellow or peels quickly. Is that true?",
      answer: "Not when genuine film, correct prep, and proper installation standards are followed. Most failures come from low-grade material or rushed workmanship. We use verified premium products, precision edge finishing, and no-compromise installation quality."
    },
    {
      question: "How long do ceramic coating and PPF last?",
      answer: "Service life depends on product grade, vehicle usage, wash habits, and maintenance quality. We provide realistic timelines and care guidance upfront. Our focus is durable results through correct process, not short-term shine for delivery day."
    },
    {
      question: "How much time does proper detailing, ceramic, or PPF work take?",
      answer: "Quality work needs correct prep, controlled application, and proper curing time. Depending on car condition and package, completion can range from same-day detailing to multi-day protection jobs. We never compromise quality by rushing the process."
    },
    {
      question: "How should I maintain my car after ceramic or PPF?",
      answer: "Use pH-neutral products, clean microfiber towels, and safe wash techniques. Avoid harsh detergents and aggressive local brush washing. We provide a practical maintenance guide at handover so your protection performs at its best for the long term."
    },
    {
      question: "How can I verify quality and avoid false promises in the market?",
      answer: "Always ask for product authenticity, clear process steps, warranty clarity, and studio transparency. At Detailing Bhai, you can review the workflow, understand what is being applied, and get recommendations based on your car's real needs. Our standard is simple: no compromise on quality, process, or honesty."
    }
  ]
};
